// extracted by mini-css-extract-plugin
export default {"Slider":"Slider_Slider__aWpao","spinner":"Slider_spinner__DbJWL"};